import React from 'react';
import Button from '../../forms/Button';
import Input from '../../forms/Input';
import Form from '../forms/FullScreenForm';
import logo from '../../../assets/images/logo.png';
import { FORGOT_PASSWORD_PATH } from '../../../constants/routes';
import { Link } from 'react-router-dom';
import Checkbox from '../../forms/Checkbox';

const LoginForm = props => {
    const canSubmit = !!(props.email && props.password);
    return (
        <Form
            onSubmit={props.onSubmit}
            canSubmit={canSubmit && !props.loading}
            header={
                // <a rel="noopener noreferrer" href="https://clearem.live/" target="_blank">
                <img className="ckp-forms-logo" src={logo} alt="Logo" />
                // </a>
            }
            body={
                <React.Fragment>
                    <Input
                        label="Email"
                        name="email"
                        type="email"
                        value={props.email}
                        onChange={props.onInput}
                        errorMessage={props.errorText}
                    />
                    <Input
                        label="Password"
                        type="password"
                        name="password"
                        value={props.password}
                        onChange={props.onInput}
                        errorMessage={props.errorText}
                    />
                    <p className="ckp-inputs-footnote">
                        <Link className="ckp-inputs-footnote-link" to={FORGOT_PASSWORD_PATH}>
                            Forgot Password?
                        </Link>
                    </p>
                    <p className="ckp-forms-input-wrapper">
                        <Checkbox
                            onChange={props.onChecked}
                            name="rememberMe"
                            checked={props.rememberMe}
                            label="Remember me"
                        />
                        {/* <span className="ckp-forms-note">
                            No login yet? Go to{' '}
                            <a rel="noopener noreferrer" href="https://clearem.live/" target="_blank">
                                clearem.live
                            </a>
                        </span> */}
                    </p>
                </React.Fragment>
            }
            footer={<Button loading={props.loading} inactive={!canSubmit} label="Sign in" />}
        />
    );
};

export default LoginForm;
